import { Badge } from '@/components/ui/badge';
import { PackageOpen, Loader, Lock, Ship, Anchor, PackageCheck } from 'lucide-react';
import type { ContainerStatus } from '../types/import-tracking.types';

const STATUS_CONFIG: Record<
  ContainerStatus,
  { label: string; className?: string; icon: React.ElementType }
> = {
  EMPTY: { label: 'Vacío', className: 'bg-muted text-foreground', icon: PackageOpen },
  LOADING: { label: 'Cargando', className: 'bg-alerta-suave text-alerta', icon: Loader },
  SEALED: { label: 'Sellado', className: 'bg-info-suave text-info', icon: Lock },
  IN_TRANSIT: { label: 'En tránsito', className: 'bg-primary/10 text-primary', icon: Ship },
  AT_PORT: { label: 'En Puerto', className: 'bg-ia-suave text-ia', icon: Anchor },
  DELIVERED: { label: 'Entregado', className: 'bg-ok-suave text-ok', icon: PackageCheck },
};

export function ContainerStatusBadge({ status }: { status: ContainerStatus }) {
  const config = STATUS_CONFIG[status];
  const Icon = config.icon;
  return (
    <Badge variant="secondary" className={`${config.className} gap-1`}>
      <Icon className="w-3 h-3" />
      {config.label}
    </Badge>
  );
}

export { STATUS_CONFIG };
